function stringToNode(element) {
    const template = document.createElement('template');
    // Never return a text node of whitespace as the result
    element = element.trim(); 
    template.innerHTML = element;

    return template.content.firstChild;
}

export {
    stringToNode
}